<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="500px">
        <el-form :model="{}" label-width="180px">
            <el-form-item :label="$t('integration.state')">
                <span>{{ detailObj.statusName }}</span>
            </el-form-item>
            <el-form-item :label="$t('public.start_time')">
                <span>{{ $timetransition(detailObj.createTime) }}</span>
            </el-form-item>
            <el-form-item :label="$t('public.end_time')">
                <span>{{ $timetransition(detailObj.updateTime) }}</span>
            </el-form-item>
            <el-form-item :label="$t('integration.reason')">
                <span>{{ detailObj.reason | reasonWay }}</span>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('buttonTitle.Close') }}</el-button>
            <el-button type="primary" @click="downloadFn" v-if="detailObj.status === 1">{{ $t('integration.download') }}</el-button>
        </div>
    </modal>
</template>

<script>
export default {
    props: ['title', 'isShow', 'detailObj'],
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        }
    },
    filters: {
        reasonWay(str) {
            switch (str) {
                case 'param_error': {
                    return $t('integration.parameter_error');
                }
                case 'no_match_data': {
                    return $t('integration.no_matching_data_found');
                }
                case 'file_have_deleted': {
                    return $t('integration.file_has_been_deleted');
                }
                case 'file_not_exist': {
                    return $t('integration.file_does_not_exist');
                }
                case 'unknown_error': {
                    return $t('integration.unknown_error');
                }
                default:
                    return '---';
            }
        }
    },
    methods: {
        downloadFn() {
            this.$emit('downloadFn', this.detailObj);
        }
    }
};
</script>

<style></style>
